'use strict';

angular.module('licensure.portal')
    .directive('portalTop', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/top/top.html',
            replace: true,
            controller: ['$scope', '$rootScope', '$stateParams', '$state', '$sce', 'Utils', 'localStorageService', 'Alerts', '$window', 'PortalPermissions', 'Saml', 'Session', 'UserStatuses', 'Enterprise', function ($scope, $rootScope, $stateParams, $state, $sce, Utils, localStorageService, Alerts, $window, PortalPermissions, Saml, Session, UserStatuses, Enterprise) {
                $scope.messages = $stateParams.messages || [];

                $scope.getPermission = function (state, variable) {
                    PortalPermissions.view(state).then(function (access) {
                        $scope[variable] = access;
                    })
                }

                //Params for SSO
                $scope.errorCode = $stateParams.errorCode;
                $scope.statusId = $stateParams.statusId;

                $scope.stateName = $state.current.name;
                $scope.loginRequired = $stateParams.loginRequired;
                $scope.portal_page = $rootScope.portal_pages[$scope.stateName];
                $scope.hideAlerts = true;
                $scope.showAccountAlerts = false; 
                if (($scope.portal_page !== undefined || $scope.portal_page != null) && typeof ($scope.portal_page.content) == "string") {
                    $scope.portal_page.content = $sce.trustAsHtml($scope.portal_page.content);
                }
                $scope.alertsCount = {length: 0};
                $scope.$watch('showAccountAlerts', function (newValue, oldValue) {
                    if (newValue == true && $state.params.path == "/dashboard") {
                        Alerts.getAlertsCount({ user_id: $rootScope.userID || $rootScope.userAccount.id }).then(function (count) {
                            $scope.alertsCount = { length: count };
                        });
                    }
                });
                $scope.$watch('$state.current.name', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if ($stateParams.keepMessages) {
                            $scope.messages = $stateParams.messages;
                        }
                        else if ($state.params && $state.params.keepMessages) {
                            $scope.messages = $state.params.messages;
                        }
                        else {
                            $scope.messages = [];
                        }
                        $scope.stateName = $state.current.name;
                        $scope.loginRequired = $stateParams.loginRequired;
                        $scope.portal_page = $rootScope.portal_pages[$scope.stateName];
                        if (($scope.portal_page !== undefined || $scope.portal_page != null) && typeof ($scope.portal_page.content) == "string") {
                            $scope.portal_page.content = $sce.trustAsHtml($scope.portal_page.content);
                        }
                    }
                });

                $scope.$watch('$state.params.path', function (newValue) {
                    if (newValue == "/dashboard") {
                        $scope.showAccountAlerts = true;
                    }
                    else {
                        $scope.showAccountAlerts = false;
                        $scope.hideAlerts = true;
                    }
                });

                $scope.$watch('$state.params.messages', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if ($state.params.keepMessages) {
                            $scope.messages = $state.params.messages;
                        }
                    }
                });

                $scope.logout = function () {
                    //Identity Provider Logout
                    if ($rootScope.userAccount && $rootScope.userAccount.has_identity_provider) {
                        var redirectURL = $rootScope.portalURL;
                        //Make sure the portal URL is a relative URL (sometimes it's the full url)
                        if (redirectURL.startsWith($window.location.origin)) {
                            redirectURL = redirectURL.replace($window.location.origin, "");
                        }
                        Saml.idpSignOut(redirectURL).then(function (ret) {
                            expireSession();
                            if (ret && ret.redirectUrl) {
                                window.location.href = ret.redirectUrl;
                            }
                            else {
                                $state.go("portal.menus.login", { messages: ["You have successfully logged out"] }, { reload: true });
                            }
                        });
                    }
                    //Regular Logout
                    else {
                        expireSession();
                        $state.go("portal.menus.login", { messages: ["You have successfully logged out"] }, {reload: true});
                    }
                };

                function expireSession() {
                    // remove existing cookie and token from local storage
                    Utils.DeleteSessionCookie(true);
                    // expire any existing session
                    Session.expireSession(true);
                    localStorageService.remove('portalAuthorizationData');
                    $rootScope.userAccount = null;
                }

                $scope.goToProfile = function () {
                    if ($state.params.path != '/profile') {
                        $state.go('portal.menus.accountProfileNew');
                    }
                };

                function loadAlerts() {
                    Alerts.getDashboardAlerts({ user_id: $rootScope.userID }).then(function (alerts) {
                        for (var a = 0; a < alerts.length; a++) {
                            if (alerts[a].color == null) {
                                alerts[a].color = 'fff6cf'; // default color
                            }
                        }

                        $scope.alerts = alerts;
                        if ($scope.alerts.length > 0) {
                            $scope.showAccountAlerts = true;
                            $scope.hideAlerts = false;
                        }
                    });
                }
                $scope.toggle = function () {
                    var x = document.getElementById("alertList");
                    if ($scope.hideAlerts == true) {
                        document.getElementById("alert").innerHTML = '<span class="caret-down"> ❯ </span> &emsp; Your account has ' + $scope.alertsCount.length + ' active alert(s)';
                        if ($scope.alerts == null) {
                            loadAlerts();
                        }
                        $scope.hideAlerts = false; 
                        x.style.display = "block";
                    } else {
                        document.getElementById("alert").innerHTML = '<span class="caret-right"> ❯ </span> &emsp; Your account has ' + $scope.alertsCount.length + ' active alert(s)';
                        $scope.hideAlerts = true; 
                        x.style.display = "none";
                    } 
                }

                $scope.acceptedMessages = [
                    "An error occurred during the login process - the NameIdentifier is missing or invalid. Please try again later or contact your system administrator.",
                    "There was not enough information to create your account. Please try again later or contact your system administrator.",
                    "There was an error when trying to create your account. Please try again later or contact your system administrator.",
                    "An error occured during the login process. Please try again later or contact your system administrator.",
                    "Your credentials are managed by a SSO. If you are unable to login via your Single Sign On service, please contact your system administrator.",
                    "You have reached the maximum number of concurrent sessions possible. Please logout from other devices and try again.",
                    "Missing enterprise id",
                    "This user account is inactive",
                    "This user account does not have access to the site",
                    "This user account does not belong to enterprise",
                    "This user account is in a status that is locked",
                    "This user account has exceeded the number of allowed inactive days and is suspended",
                    "Account creation failed - user with identical email already exists.",
                    "Internal server error",
                    "Operation canceled",
                    "lockedMessage",
                    "duplicatePreventionText",
                ];

                if ($scope.errorCode) {
                    //Passing messages from .net to frontend
                    //Have to sanitize the message because of javascript injection - some of these messages might be html
                    if ($scope.errorCode < $scope.acceptedMessages.length) {
                        var errorMessage = $scope.acceptedMessages[$scope.errorCode];
                        if (!$scope.messages) { $scope.messages = []; }
                        if (errorMessage === "lockedMessage") {
                            if ($scope.statusId) {
                                //Get the status locked message
                                UserStatuses.getUserStatusLockedMessage($scope.statusId).then(function (lockedText) {
                                    errorMessage = lockedText;
                                    $scope.messages.push(errorMessage);
                                });
                            }
                        }
                        else if (errorMessage === "duplicatePreventionText") {
                            //Get the duplicate prevention message
                            Enterprise.getDuplicatePreventionText().then(function (duplicateText) {
                                errorMessage = duplicateText;
                                $scope.messages.push(errorMessage);
                            });
                        }
                        else {
                            $scope.messages.push(errorMessage);
                        }
                    }
                }
            }],
            link: function (scope, elem, attrs, ctrl) {
            }
        };
    }])
;